import PropTypes from 'prop-types'

import MenuIcon from 'assets/images/icons/bars-regular.svg'
import BookmarkIcon from 'assets/images/icons/heart-regular.svg'
import SearchIcon from 'assets/images/icons/search-regular.svg'
import BookmarksIconStatus from 'components/lib/bookmarks/icon_status'
import Button from 'components/lib/html_elements/button'
import Icon from 'components/lib/icon'
import Sheet from 'components/lib/sheet'
import SheetBody from 'components/lib/sheet/body'
import SheetHeader from 'components/lib/sheet/header'
import { useSheet } from 'components/lib/sheet/hooks'

import styles from './index.css'

const Container = ({ children, searchSheet, hasNotifications }) => {
  const { id, toggleSheet } = useSheet('navigation')

  return (
    <div className={styles.base}>
      {searchSheet && (
        <a
          className={styles.searchLink}
          href="/components/therapists/search_sheet_component"
          rel="nofollow"
          data-props={JSON.stringify(searchSheet)}
        >
          <Icon icon={<SearchIcon />} />
        </a>
      )}
      <a
        className={styles.bookmarkLink}
        href="/components/therapists/bookmarks_sheet/component"
        rel="nofollow"
      >
        <Icon icon={<BookmarkIcon />} />
        <BookmarksIconStatus />
      </a>
      <Button className={styles.button} onClick={() => toggleSheet(true)}>
        <Icon icon={<MenuIcon />} />
        {hasNotifications && <div className={styles.notificationLight}></div>}
      </Button>

      <Sheet id={id}>
        <SheetHeader />
        <SheetBody className={styles.body}>
          {children && <div dangerouslySetInnerHTML={{ __html: children }} />}
        </SheetBody>
      </Sheet>
    </div>
  )
}

Container.propTypes = {
  children: PropTypes.string.isRequired,
  hasNotifications: PropTypes.bool.isRequired,
  searchSheet: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      excludeFilters: PropTypes.array,
      therapistsPath: PropTypes.string
    })
  ])
}

export default Container
